import { register, getPrefix } from '../../../Utils'

const OffcanvasContainer = el => {
  const prefix = getPrefix(el)
  const toggler = el.querySelectorAll('.' + prefix + 'offcanvas-toggler')
  const offcanvasContent = el.querySelector('#offcanvasContent')
  const offcanvasBackdrop = el.querySelector('#offcanvasBackdrop')

  const toggleOffcanvas = () => {
    if (offcanvasContent.classList.contains(prefix + 'is--active')) {
      offcanvasContent.classList.remove(prefix + 'is--active')
      offcanvasBackdrop.classList.remove(prefix + 'is--active')
    } else {
      offcanvasContent.classList.add(prefix + 'is--active')
      offcanvasBackdrop.classList.add(prefix + 'is--active')
    }
  }

  toggler.forEach(el => {
    el.addEventListener('click', toggleOffcanvas)
  })
}

register('OffcanvasContainer', OffcanvasContainer)
